<template> 
	<div class="lesson-message">
		<div class="my-2" :key="index" v-for="(item, index) in lessonMessageList">
			<div>
				<span class="message-sender">{{ sender(item.user_id, item.nickname) }}</span>&nbsp;
				<span class="message-created-date">{{ item.created_date | formatLessonMessageCreatedDate }}</span>&nbsp;
				<a v-if="item.user_id==loggedUserID" class="del-button" href="#" @click.prevent.stop="deleteMessage(item.message_id)">{{ $t('LessonMessage.delete') }}</a>
			</div>
			<div class="message-text"  v-html="textToHtml(item.message_text)"></div>
		</div>

		<form v-if="!isTrainingFinished" id="form" class="mt-2" @submit.prevent="sendMessage">
			<b-form-textarea
				id="message"
				ref="message"
				v-model="form.message"
				rows="3"
				size="sm"
				:placeholder="messagePlaceholder"
				required
			></b-form-textarea>
			<div class="text-right mt-1">
				<b-button type="submit" squared variant="warning" class="main-button">{{ $t('LessonMessage.send') }}</b-button>
			</div>
		</form>
	</div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import moment from "moment"

export default {
	name: 'LessonMessage',
	props: {
		lesson: {
			title: String,
			picture_url: String,
			description: String,
			from_date: String,
			to_date: String,
			spoken_language: String,
			things_to_bring: String,
			max_member: Number,
			label: Array,
			ticket: Number,
			reservation_count: Number,
			trainer_nickname: String,
			trainer_picture_url: String,
			same_day_reservation_flg: Boolean,
			user_id: String
		},
		lessonId: String,
	},
	data() {
	    return {
			lessonMessageList: [],
			isTrainingFinished: true,
			timerID: null,
			form: {
				message: "",
			},
	    }
	},
	computed: {
		isTrainer: function() {
			return this.$store.state.isTrainer;
		},
		loggedUserID: function() {
			return this.$store.state.loggedUserID;
		},
		messagePlaceholder: function() {
			if (this.lesson.max_member > 1) {
				return this.$t('LessonMessage.messageText2');
			} else {
				return this.$t('LessonMessage.messageText');
			}
		}
	},
	mounted() {
		this.timerID = setInterval(this.init, 5*1000);
		this.init();
	},
	beforeDestroy() {
		if (this.timerID != null) {
			clearInterval(this.timerID);
		}
	},
	watch: {
		lesson: function (val) {
			this.checkTime();
		}
	},
	methods: {
		init() {
			this.getLessonMessage();
			this.checkTime();
		},
		getLessonMessage() {
			axios.get(EMSStyleAPIBaseURL + 'lesson-message/' + this.lessonId)
			.then(response => {
				this.lessonMessageList = response.data
				.sort((a, b) => {
					//created_dateの昇順
					if(a.created_date > b.created_date) return 1;
					if(a.created_date < b.created_date) return -1;
					return 0;
				});
				this.lessonMessageList.forEach(item => {
					item.created_date = item.created_date + "Z";
				});
			})
			.catch((error) => {
				console.error(error)
				clearInterval(this.timerID);
				this.$swal({
					text: this.$t('general.errorMessage'),
					icon: 'error',
				});
			});
		},
		checkTime() {
			if (this.lesson.to_date == null) return;
			let now = moment();
			if (moment(this.lesson.to_date).isBefore(now)) {
				this.isTrainingFinished = true;
				if (this.timerID != null) {
					clearInterval(this.timerID);
				}
			} else {
				this.isTrainingFinished = false;
			}
		},
		sender(userId, nickname) {
			if (userId == this.lesson.user_id) {
				return this.$t('LessonDetail.trainer') + ":" + nickname;
			} else {
				return nickname;
			}

		},
	    sendMessage: function (e) {
			if (this.form.message.length > 1024) {
				this.$swal({
					text: this.$t('LessonMessage.errorMessageLengthMessage'),
					icon: 'error',
				});
				return;
			}
			let loader = this.$loading.show()
			var formData = JSON.stringify({
			    lesson_id: this.lessonId,
				message_text: this.form.message
			});
			axios.post(EMSStyleAPIBaseURL + 'lesson-message', formData, {
			    headers: {
				"Content-Type": "application/json"
			    }
			})
			.then(response => {
			    //console.log(response.data)
				this.form.message = "";
			    loader.hide()
				this.init();
			})
			.catch((error) => {
			    loader.hide()
			    console.error(error)
				this.$swal({
					text: this.$t('LessonMessage.errorSendMessage'),
					icon: 'error',
				});
			});
	    },
		deleteMessage(messageId) {
			this.$swal({
				text: this.$t('LessonMessage.confirmationDeleteMessage'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'OK'
			}).then((result) => {
				if (result.value) {
					let loader = this.$loading.show()
					axios.delete(EMSStyleAPIBaseURL + 'lesson-message/' + messageId)
					.then(response => {
						loader.hide()
						this.init();
						this.$swal({
							text: this.$t('LessonMessage.doneDeleteMessage'),
							iconColor: 'transparent',
							iconHtml: '<img src="assets/images/check_ok.png" width="88" height="88">',
						});
					})
					.catch((error) => {
						loader.hide()
						console.error(error)
						this.$swal({
							text: this.$t('LessonMessage.errorDeleteMessage'),
							icon: 'error',
						});
					});
				}
			})
			.catch(err => {
				// An error occurred
				loader.hide()
				console.error(err)
			})
	    },
		// 本文整形
		textToHtml: function (text) {
			return this.htmlspecialchars(text)
			.replace(/\n/g, '<br>');
		},
		// 特殊文字を HTML エンティティに変換する
		htmlspecialchars: function (str){
			return String(str).replace(/&/g,"&amp;")
			.replace(/"/g,"&quot;")
			.replace(/</g,"&lt;")
			.replace(/>/g,"&gt;");
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lesson-message{
	max-height:calc(100vh / 2);
	overflow-y: scroll;
	scrollbar-color: #999999 #e5e5e5;
	border-top :solid 1px #999999;
	padding-left: 1rem;
	padding-right: 1rem;
}
.message-sender {
	font-size: 0.7rem;
}
.message-created-date {
	font-size: 0.7rem;
}
.message-text {
	font-size: 0.8rem;
}
.del-button {
	font-size: 0.7rem;
	font-weight:bold;
}
a.del-button {
	color:#888888;
	text-decoration:none;
}
a:visited.del-button {
	color:#888888;
	text-decoration:none;
}
a:hover.del-button {
	color:#888888;
	text-decoration:underline;
}
a:active.del-button {
	color:#666666;
	text-decoration:none;
}
</style>
